export var AmortizationType;
(function (AmortizationType) {
    AmortizationType[AmortizationType["MINIMAL"] = 0] = "MINIMAL";
    AmortizationType[AmortizationType["FLAT"] = 1] = "FLAT";
    AmortizationType[AmortizationType["CONSTANT"] = 2] = "CONSTANT";
    AmortizationType[AmortizationType["MARKET_SPECIFIC"] = 3] = "MARKET_SPECIFIC";
})(AmortizationType || (AmortizationType = {}));
